import React from 'react';
import SynthesisMatrixQuestion from './SynthesisMatrixQuestion';
import FillInBlankQuestion from './FillInBlankQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import TrueFalseNotGivenQuestion from './TrueFalseNotGivenQuestion';
import JobComparisonQuestion from './JobComparisonQuestion';
import MatchingQuestion from './MatchingQuestion';
import ClassificationQuestion from './ClassificationQuestion';
import TableCompletionQuestion from './TableCompletionQuestion ';

const QuestionRenderer = ({
  question,
  result,
  currentAnswer,
  submittedFirstTime,
  showExplanation,
  canRetry,
  onAnswerChange,
  onToggleExplanation,
  allQuestions,
  allAnswers, viewMode = false // ✅ thêm
}) => {
  const commonProps = {
    question,
    result,
    currentAnswer,
    submittedFirstTime,
    showExplanation,
    onAnswerChange,
    onToggleExplanation,
    allQuestions
  };

  // ✅ Logic disable: áp dụng cho tất cả scenarios
  const isDisabled = viewMode || (submittedFirstTime && !canRetry && result?.isCorrect);


  switch (question.question_type) {
    case 'synthesis_matrix':
      return <SynthesisMatrixQuestion {...commonProps} isDisabled={isDisabled} />;
    case 'fill_in_blank':
      return <FillInBlankQuestion {...commonProps} isDisabled={isDisabled} />;
    case 'multiple_choice':
      return <MultipleChoiceQuestion {...commonProps} canRetry={canRetry} isDisabled={isDisabled} />;
    case 'true_false_not_given':
    case 'true_false':
      return <TrueFalseNotGivenQuestion {...commonProps} canRetry={canRetry} isDisabled={isDisabled} />;
    case 'job_comparison':
      return (
        <JobComparisonQuestion
          {...commonProps}
          questions={allQuestions?.filter(q => q.question_type === 'job_comparison')}
          currentAnswers={allAnswers}
          canRetry={canRetry}
          isDisabled={isDisabled}
        />
      );
    case 'matching':
      return <MatchingQuestion {...commonProps} canRetry={canRetry} allAnswers={allAnswers} isDisabled={isDisabled} />;
    case 'classification':
      return <ClassificationQuestion {...commonProps} canRetry={canRetry} isDisabled={isDisabled} />;
    case 'table_completion':
      return <TableCompletionQuestion {...commonProps} canRetry={canRetry} isDisabled={isDisabled} />;
    default:
      return <MultipleChoiceQuestion {...commonProps} canRetry={canRetry} isDisabled={isDisabled} />;
  }
};

export default QuestionRenderer;
